import AddEditMailTemplate from './AddEditMailTemplate';

export default AddEditMailTemplate;